document.addEventListener('DOMContentLoaded', function() {
  function updateButtonText() {
    // Alteração do "Buy it now"
    var buyNowButtons = document.querySelectorAll('.shopify-payment-button__button--unbranded');
    buyNowButtons.forEach(function(button) {
      if (button.textContent.trim() === 'Buy it now') {
        button.textContent = 'Comprar agora';
      }
    });

    // Alteração do "Availability"
    var availabilityTitles = document.querySelectorAll('h4, .widget-title, .filter-title, .sidebar-title');
    availabilityTitles.forEach(function(title) {
      if (title.textContent.trim() === 'Availability') {
        title.textContent = 'Disponibilidade';
      }
    });

    // Alteração do "Price"
    var priceTitles = document.querySelectorAll('h4, .widget-title, .filter-title, .sidebar-title');
    priceTitles.forEach(function(title) {
      if (title.textContent.trim() === 'Price') {
        title.textContent = 'Preço';
      }
    });

    // Alteração do "Add to basket"
    var addToBasketButtons = document.querySelectorAll('.theme-btn-1.btn-effect-1');
    addToBasketButtons.forEach(function(button) {
      if (button.textContent.trim() === 'Add to basket') {
        button.textContent = 'Adicionar ao carrinho';
      }
    });
  }

  // Executa imediatamente
  updateButtonText();

  // Aplica após um atraso para capturar elementos dinâmicos
  setTimeout(updateButtonText, 1000);

  // Observa mudanças no DOM
  const observer = new MutationObserver(updateButtonText);
  observer.observe(document.body, { childList: true, subtree: true });
});